import updateSharedCalendarsInitialState from '../data/mutators/updateSharedCalendarsInitialState';
import loadSharedCalendarsConfiguration from '../services/loadSharedCalendarsConfiguration';
import parseCalendarFoldersResponse from '../utils/parseCalendarFoldersResponse';
import { PerformanceDatapoint } from 'owa-analytics';
import { DatapointStatus } from 'owa-analytics/lib/types/DatapointEnums';
import {
    initializeCalendarPublishingPermissionStore,
    loadCalendarPublishingPermissions,
} from 'owa-calendar-sharing/lib/actions/calendarPublishing';
import { trace } from 'owa-trace';
import { isFeatureEnabled } from 'owa-feature-flags';
import { setCalendarPublishingErrorStateError } from 'owa-calendar-sharing/lib/actions/calendarPublishing';
import CalendarPublishingError from 'owa-calendar-sharing/lib/store/schema/CalendarPublishingError';

function loadPublishInfo(
    folderId: string,
    calendarId: string,
    calendarColor: string,
    calendarName: string
) {
    loadCalendarPublishingPermissions(folderId, calendarId, calendarColor, calendarName);
}

/**
 * 1. Gets the calendar folder and groups data from the server
 * 2. Parses the data to get the initial state of the shared calendars
 * 3. Calls an action to update the store with the parsed data
 * 4. For each calendar loads the publish info
 */
export default async function initSharedCalendarsConfiguration() {
    try {
        var dataPoint = new PerformanceDatapoint('InitSharedCalendarsOption');
        let calendarFoldersResponse = await loadSharedCalendarsConfiguration();
        await initializeCalendarPublishingPermissionStore();

        setCalendarPublishingErrorStateError(null); // Reset publishing error

        if (
            calendarFoldersResponse.CalendarFolders &&
            calendarFoldersResponse.CalendarFolders.length &&
            calendarFoldersResponse.CalendarGroups &&
            calendarFoldersResponse.CalendarGroups.length
        ) {
            dataPoint.end();
            let initialViewState = parseCalendarFoldersResponse(calendarFoldersResponse);
            updateSharedCalendarsInitialState(initialViewState);
            isFeatureEnabled('cal-publishing-settings') &&
                initialViewState.calendarsPublish &&
                initialViewState.calendarsPublish.map(calendar => {
                    loadPublishInfo(
                        calendar.folderId,
                        '',
                        calendar.hexColorString,
                        calendar.calendarName
                    );
                });

            return true;
        } else {
            setCalendarPublishingErrorStateError(CalendarPublishingError.InitialLoadFailure);
            dataPoint.endWithError(
                DatapointStatus.ServerError,
                new Error('Request returned empty response')
            );
            return false;
        }
    } catch (e) {
        setCalendarPublishingErrorStateError(CalendarPublishingError.InitialLoadFailure);
        dataPoint.endWithError(DatapointStatus.RequestNotComplete, new Error('Request failed'));
        trace.warn(e.message || 'initSharedCalendarsConfiguration failed');
        return false;
    }
}
